// src/screens/auth/ForgotPasswordScreen.js
// 51차: 색 theme.js 단일화 — COLORS 참조 / 성공 체크 초록 통일, 골드버튼 텍스트 ON_GOLD
// 74차: 상단 뒤로가기 라벨 "돌아가기" → "뒤로" (다른 화면들과 통일)
// 74차: SafeAreaView가 fullScreenModal 프레젠테이션 안에서 top inset을 못 잡아
// 뒤로가기 버튼이 상태바에 붙어보이던 문제 → useSafeAreaInsets()로 직접 paddingTop
// 지정 (LoginScreen.js 73차에서 WebView 모달에 적용했던 것과 동일한 원인/해법)
// 76차: 커스텀 뒤로가기 헤더 → 공통 AppHeader로 교체(AppHeader가 자체적으로 top inset을
// 처리하므로 위 74차의 수동 paddingTop도 함께 제거)
// 78차: "재설정 링크 보내기"/"로그인으로 돌아가기" 버튼(인라인 골드 fill)을 공용
// GradientButton(Primary)으로 교체
import React, { useState } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, TextInput,
  StyleSheet,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { sendPasswordReset } from '../../services/authService';
import AppHeader from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import { COLORS } from '../../constants/theme';

const BG = COLORS.bg;
const SURFACE = COLORS.surface;
const BORDER = 'rgba(212,168,67,0.2)';
const TEXT = COLORS.text;
const TEXT_SEC = COLORS.textSec;
const TEXT_MUTED = 'rgba(255,255,255,0.35)';
const GREEN = COLORS.green;

export default function ForgotPasswordScreen({ navigation }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSend = async () => {
    if (!email.includes('@')) {
      showAlert('오류', '올바른 이메일을 입력해주세요.');
      return;
    }
    try {
      setLoading(true);
      await sendPasswordReset(email);
      setSent(true);
    } catch (e) {
      showAlert('오류', '이메일 전송에 실패했습니다. 가입된 이메일인지 확인해주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <View style={s.container}>
      <AppHeader showBack centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }}>비밀번호 찾기</Text>} />

      <View style={s.body}>
        <Text style={s.title}>비밀번호 재설정</Text>
        <Text style={s.desc}>가입한 이메일로 재설정 링크를 보내드립니다.</Text>

        {sent ? (
          <View style={s.sentBox}>
            <Ionicons name="checkmark-circle" size={56} color={GREEN} />
            <Text style={s.sentTitle}>이메일이 전송되었습니다</Text>
            <Text style={s.sentDesc}>{email}으로{'\n'}재설정 링크를 보냈습니다.{'\n'}메일함을 확인해주세요.</Text>
            <GradientButton label="로그인으로 돌아가기" onPress={() => navigation.goBack()} />
          </View>
        ) : (
          <>
            <Text style={s.label}>이메일</Text>
            <View style={s.inputWrap}>
              <Ionicons name="mail-outline" size={18} color={TEXT_MUTED} style={{ marginRight: 8 }} />
              <TextInput
                style={s.input}
                placeholder="가입한 이메일을 입력해주세요"
                placeholderTextColor={TEXT_MUTED}
                value={email}
                onChangeText={setEmail}
                keyboardType="email-address"
                autoCapitalize="none"
              />
            </View>
            <GradientButton
              label={loading ? '전송 중...' : '재설정 링크 보내기'}
              onPress={handleSend}
              disabled={loading}
            />
          </>
        )}
      </View>
    </View>
  );
}

const s = StyleSheet.create({
  container: { flex: 1, backgroundColor: BG },
  body: { paddingHorizontal: 24, paddingTop: 16 },
  title: { fontSize: 26, fontWeight: '900', color: TEXT, marginBottom: 8 },
  desc: { fontSize: 14, color: TEXT_SEC, marginBottom: 28, lineHeight: 22 },
  label: { color: TEXT, fontSize: 13, fontWeight: '600', marginBottom: 8 },
  inputWrap: {
    flexDirection: 'row', alignItems: 'center',
    backgroundColor: SURFACE, borderRadius: 10,
    paddingHorizontal: 14, height: 52, marginBottom: 20,
    borderWidth: 1, borderColor: BORDER,
  },
  input: { flex: 1, color: TEXT, fontSize: 15 },
  sentBox: { alignItems: 'center', paddingTop: 20, gap: 16 },
  sentTitle: { fontSize: 20, fontWeight: '800', color: TEXT },
  sentDesc: { fontSize: 14, color: TEXT_SEC, textAlign: 'center', lineHeight: 24 },
});